//const _ = require('lodash');

module.exports = function ($stateProvider) {
    $stateProvider
        .state('shop.inspiration', {
            url: '/help',
            data: {
                analytics: 'bws:web:help',
                pageMetadata: [
                    'PageMetadataService', function (pageMetadataService) {
                        return pageMetadataService.getMetadata({ name: 'Help - BWS Online' });
                    }
                ]
            },
            views: {
                'dynamic-content-top@': {
                    template: '<oly-dynamic-content oly-dc-url-schedule class="dynamic-content2-panelTop"></oly-dynamic-content>'
                },
                'dynamic-content-bottom@': {
                    template: '<oly-dynamic-content oly-dc-url-schedule="bottom" class="dynamic-content2-panelBottom"></oly-dynamic-content>'
                },
                'aem-view@': {
                    template: '<wow-aem-portal project="generic" is-partial="true"></wow-aem-portal>'
                },
                'center-panel@': {
                    controller: [
                        '$state', '$location', function ($state, $location) {
                            if ($location.path() === '/help') {
                                $state.go('shop.helpcenter');
                            }
                        }
                    ]
                }
            }
        })
        .state('shop.helpcenter', {
            url: '/help-centre',
            views: {
                'center-panel@': {
                    template: '<help-center></help-center>'
                }
            }
        })
        .state('shop.inspiration.selfexclusion', {
            url: '/self-exclusion',
            data: {
                analytics: 'bws:web:help:self-exclusion',
                pageMetadata: [
                    'PageMetadataService', function (pageMetadataService) {
                        return pageMetadataService.getMetadata({ name: 'Self Exclusion - BWS Online' });
                    }
                ]
            },
            views: {
                'center-panel@': {
                    template: '<wow-selfexclusion-form class="signupPage-form"></wow-selfexclusion-form>'
                },
                'dynamic-content-top@': {
                    template: '<oly-dynamic-content oly-dc-url-schedule class="dynamic-content2-panelTop"></oly-dynamic-content>'
                },
                'dynamic-content-bottom@': {
                    template: '<oly-dynamic-content oly-dc-url-schedule="bottom" class="dynamic-content2-panelBottom"></oly-dynamic-content>'
                },
                'aem-view@': {
                    template: '<wow-aem-portal project="generic" is-partial="true"></wow-aem-portal>'
                }
            }
        })
        .state('shop.inspiration.selfexclusion.confirm', {
            url: '/confirm',
            data: {
                pageMetadata: [
                    'PageMetadataService', function (pageMetadataService) {
                        return pageMetadataService.getMetadata({ name: 'Self Exclusion Confirmation- BWS Online' });
                    }
                ]
            },
            views: {
                'center-panel@': {
                    template: '<wow-selfexclusion-confirm class="signupPage-form"></wow-selfexclusion-confirm>'
                },
                'dynamic-content-top@': {
                    template: '<oly-dynamic-content oly-dc-url-schedule class="dynamic-content2-panelTop"></oly-dynamic-content>'
                },
                'dynamic-content-bottom@': {
                    template: '<oly-dynamic-content oly-dc-url-schedule="bottom" class="dynamic-content2-panelBottom"></oly-dynamic-content>'
                },
                'aem-view@': {
                    template: '<wow-aem-portal project="generic" is-partial="true"></wow-aem-portal>'
                }
            }
        })
        .state('shop.inspiration.selfexclusion.error', {
            url: '/error',
            data: {
                pageMetadata: [
                    'PageMetadataService', function (pageMetadataService) {
                        return pageMetadataService.getMetadata({ name: 'Self Exclusion Error- BWS Online' });
                    }
                ]
            },
            views: {
                'center-panel@': {
                    template: '<wow-selfexclusion-error class="signupPage-form"></wow-selfexclusion-error>'
                },
                'dynamic-content-top@': {
                    template: '<oly-dynamic-content oly-dc-url-schedule class="dynamic-content2-panelTop"></oly-dynamic-content>'
                },
                'dynamic-content-bottom@': {
                    template: '<oly-dynamic-content oly-dc-url-schedule="bottom" class="dynamic-content2-panelBottom"></oly-dynamic-content>'
                },
                'aem-view@': {
                    template: '<wow-aem-portal project="generic" is-partial="true"></wow-aem-portal>'
                }
            }
        })
        .state('shop.inspiration.clickandcollect', {
            url: '/pick-up',
            data: {
                analytics: 'bws:web:help:pick up'
            },
            views: {
                'dynamic-content-top@': {
                    template: '<oly-dynamic-content oly-dc-url-schedule class="dynamic-content2-panelTop"></oly-dynamic-content>'
                },
                'center-panel@': {
                    template: '<bws-click-and-collect></bws-click-and-collect>'
                },
                'dynamic-content-bottom@': {
                    template: '<oly-dynamic-content oly-dc-url-schedule="bottom" class="dynamic-content2-panelBottom"></oly-dynamic-content>'
                },
                'aem-view@': {
                    template: '<wow-aem-portal project="generic" is-partial="true"></wow-aem-portal>'
                }
            }
        })
        .state('shop.inspiration.delivery', {
            url: '/delivery',
            data: {
                analytics: 'bws:web:help:delivery'
            },
            views: {
                'dynamic-content-top@': {
                    template: '<oly-dynamic-content oly-dc-url-schedule class="dynamic-content2-panelTop"></oly-dynamic-content>'
                },
                'center-panel@': {
                    template: '<bws-delivery-help-page></bws-delivery-help-page>'
                },
                'dynamic-content-bottom@': {
                    template: '<oly-dynamic-content oly-dc-url-schedule="bottom" class="dynamic-content2-panelBottom"></oly-dynamic-content>'
                },
                'aem-view@': {
                    template: '<wow-aem-portal project="generic" is-partial="true"></wow-aem-portal>'
                }
            }
        })
        .state('shop.inspiration.win', {
            url: '^/win',
            data: {
                analytics: `bws:web:popular links:win`,
                pageMetadata: [
                    'PageMetadataService', function (pageMetadataService) {
                        return pageMetadataService.getMetadata({ name: 'Win - BWS Online' });
                    }
                ]
            }
        })
        .state('shop.inspiration.cocktailrecipes.page', {
            url: '/:page'
        })
        .state('shop.inspiration.win.winners', {
            url: '/competition-winners',
            data: {
                analytics: `bws:web:competition:winners`,
                pageMetadata: [
                    'PageMetadataService', function (pageMetadataService) {
                        return pageMetadataService.getMetadata({ name: 'Competition Winners - BWS Online' });
                    }
                ]
            }
        })
        .state('shop.inspiration.win.page', {
            url: '/:page',
            data: {
                analytics: [
                    '$state', function ($state) {
                        return `bws:web:popular links:win:${$state.params.page}`;
                    }
                ]
            },
            views: {
                'center-panel@': {
                    template: '<wow-competition class="section--type-4 display-block"></wow-competition>',
                    controller: [
                        'SettingsService', function (settingsService) {

                            function loadRecaptcha() {
                                const el = document.createElement('script');
                                el.src = 'https://www.google.com/recaptcha/api.js';
                                document.body.appendChild(el);
                            }

                            //Call the frontend setting responsible for toggling the display of Google recaptcha
                            settingsService.getSettingValue('GoogleReCaptcha', 'EnableGoogleReCaptcha').then(function (response) {


                                const loadRecaptchaScript = response;

                                if (loadRecaptchaScript) {
                                    //Load recaptcha script
                                    loadRecaptcha();
                                }
                            });
                        }
                    ]
                }
            }

        })
        .state('shop.inspiration.guides', {
            url: '^/guides',
            data: {
                analytics: `bws:web${window.location.pathname.replace(/\//g, ':')}`,
                dynamicallyRenderAnalyticsWith: `bws:web`
            }
        })
        .state('shop.inspiration.guides.page', {
            url: '/:page',
            data: {
                analytics: `bws:web${window.location.pathname.replace(/\//g, ':')}`,
                dynamicallyRenderAnalyticsWith: `bws:web`
            }
        })
        .state('shop.inspirationcard', {
            url: '/discover/card/{id}?name',
            data: {
                analytics: `bws:web:discover`
            },
            views: {
                'center-panel@': {
                    template: '<wow-loading-spinner></wow-loading-spinner>'
                },
                'left-panel@': {
                    controller: [
                        '$state', '$stateParams', 'InspirationService', function ($state, $stateParams, inspirationService) {
                            inspirationService.getDiscoverPathForCard($stateParams.id).then(function (pathToCard) {
                                if (pathToCard.Page === null || pathToCard.Page.Parent === null) {
                                    $state.go('shop.404error');
                                }

                                $state.go('shop.inspiration.parent.child', {
                                    parent: pathToCard.Parent.Page.UrlPart,
                                    child: pathToCard.Page.UrlPart,
                                    cardId: $stateParams.id,
                                    name: $stateParams.name
                                },
                                    {
                                        location: 'replace'
                                    });
                            });
                        }
                    ]
                }
            }
        })
        .state('shop.inspiration.parent', {
            url: '/:parent',
            data: {
                analytics: `bws:web${window.location.pathname.replace(/\//g, ':')}`,
                dynamicallyRenderAnalyticsWith: `bws:web`
            },
            views: {
                'center-panel@': {
                    controller: [
                        '$scope', '$stateParams', function ($scope, $stateParams) {
                            $scope.pageId = $stateParams.parent;
                        }
                    ]
                },
                'sticky-header@': {
                    controller: [
                        'BreakpointsService', 'SettingsService', '$scope', '$stateParams', 'InspirationService',
                        function (breakpointsService, settingsService, $scope, $stateParams, inspirationService) {
                            $scope.breakpointsService = breakpointsService;
                            $scope.inspirationService = inspirationService;
                            settingsService.getSettingValue('OneSite', 'SmallFormatCentrePanelSlideEnabled').then(function (setting) {
                                $scope.smallFormatCentrePanelSlideEnabled = setting;
                            });
                            $scope.redirectTo = 'shop.inspiration';

                            inspirationService.getNavigationItems().then(function (navItems) {
                                const navItem = inspirationService.findNavigationItemsByName(navItems, $stateParams.parent);
                                $scope.title = navItem.Name;
                            });
                        }
                    ],
                    template: '<oly-sticky-header-with-text ng-if="breakpointsService.isSmallFormat() && smallFormatCentrePanelSlideEnabled && inspirationService.isChildlessItem()"></oly-sticky-header-with-text>'
                }
            }
        })
        .state('shop.inspiration.parent.child', {
            url: '/:child',
            views: {
                'center-panel@': {
                    controller: [
                        '$scope', '$stateParams', function ($scope, $stateParams) {
                            $scope.pageId = $stateParams.child;
                        }
                    ],
                    template: require('../../components/inspiration/inspiration-center-panel-template.html').trim()
                },
                'sticky-header@': {
                    controller: [
                        'BreakpointsService', 'SettingsService', '$scope', '$stateParams', 'InspirationService',
                        function (breakpointsService, settingsService, $scope, $stateParams, inspirationService) {
                            $scope.breakpointsService = breakpointsService;
                            settingsService.getSettingValue('OneSite', 'SmallFormatCentrePanelSlideEnabled').then(function (setting) {
                                $scope.smallFormatCentrePanelSlideEnabled = setting;
                            });
                            $scope.redirectTo = 'shop.inspiration';

                            inspirationService.getNavigationItems().then(function (navItems) {
                                const navItem = inspirationService.findNavigationItemsByName(navItems, $stateParams.parent, $stateParams.child);
                                $scope.title = navItem.Name;
                            });
                        }
                    ],
                    template: '<oly-sticky-header-with-text ng-if="breakpointsService.isSmallFormat() && smallFormatCentrePanelSlideEnabled"></oly-sticky-header-with-text>'
                }
            },
            data: {
                showBothPanelsInSmallFormat: true,
                analytics: `bws:web${window.location.pathname.replace(/\//g, ':')}`,
                dynamicallyRenderAnalyticsWith: `bws:web`
            }
        });


    $stateProvider
        .state('shop.orias', {
            url: '/orias',
            data: {
                pageMetadata: [
                    'PageMetadataService', function (pageMetadataService) {
                        return pageMetadataService.getMetadata({ name: 'Orias' });
                    }
                ],
                analytics: `bws:web:orias`,
                noIndex: true
            },

            views: {
                'dynamic-content-top@': {
                    template: '<oly-dynamic-content oly-dc-url-schedule class="dynamic-content2-panelTop"></oly-dynamic-content>'
                },

                'dynamic-content-bottom@': {
                    template: '<oly-dynamic-content oly-dc-url-schedule="bottom" class="dynamic-content2-panelBottom"></oly-dynamic-content>'
                },
                'aem-view@': {
                    template: '<wow-aem-portal project="generic" is-partial="true"></wow-aem-portal>'
                }
            }
        })
        .state('shop.orias.parent', {
            url: '/:parent',
            data: {
                analytics: [
                    '$stateParams', function ($stateParams) {
                        return `bws:web:orias:${$stateParams.parent}`;
                    }
                ]
            },
            views: {
                'center-panel@': {
                    controller: [
                        '$scope', '$stateParams', function ($scope, $stateParams) {
                            $scope.pageId = $stateParams.parent;
                        }
                    ]
                },

                'sticky-header@': {
                    controller: [
                        'BreakpointsService', 'SettingsService', '$scope', '$stateParams', 'InspirationService',
                        function (breakpointsService, settingsService, $scope, $stateParams, inspirationService) {
                            $scope.breakpointsService = breakpointsService;
                            $scope.inspirationService = inspirationService;
                            settingsService.getSettingValue('OneSite', 'SmallFormatCentrePanelSlideEnabled').then(function (setting) {
                                $scope.smallFormatCentrePanelSlideEnabled = setting;
                            });

                            $scope.redirectTo = 'shop.orias';
                            inspirationService.getNavigationItems().then(function (navItems) {
                                const navItem = inspirationService.findNavigationItemsByName(navItems, $stateParams.parent);
                                $scope.title = navItem.Name;
                            });
                        }
                    ],


                    template: '<oly-sticky-header-with-text ng-if="breakpointsService.isSmallFormat() && smallFormatCentrePanelSlideEnabled && inspirationService.isChildlessItem()"></oly-sticky-header-with-text>'
                }
            }
        })
        .state('shop.orias.parent.child', {
            url: '/:child',
            views: {
                'center-panel@': {
                    controller: [
                        '$scope', '$stateParams', function ($scope, $stateParams) {
                            $scope.pageId = $stateParams.child;
                        }
                    ],
                    template: require('../../components/inspiration/inspiration-center-panel-template.html').trim()
                },

                'sticky-header@': {
                    controller: [
                        'BreakpointsService', 'SettingsService', '$scope', '$stateParams', 'InspirationService',
                        function (breakpointsService, settingsService, $scope, $stateParams, inspirationService) {
                            $scope.breakpointsService = breakpointsService;
                            settingsService.getSettingValue('OneSite', 'SmallFormatCentrePanelSlideEnabled').then(function (setting) {
                                $scope.smallFormatCentrePanelSlideEnabled = setting;
                            });

                            $scope.redirectTo = 'shop.orias';
                            inspirationService.getNavigationItems().then(function (navItems) {
                                const navItem = inspirationService.findNavigationItemsByName(navItems, $stateParams.parent, $stateParams.child);
                                $scope.title = navItem.Name;
                            });
                        }
                    ],

                    template: '<oly-sticky-header-with-text ng-if="breakpointsService.isSmallFormat() && smallFormatCentrePanelSlideEnabled"></oly-sticky-header-with-text>'
                }
            },

            data: {
                analytics: [
                    '$stateParams', function ($stateParams) {
                        return `bws:web:orias:${$stateParams.parent}`;
                    }
                ],
                showBothPanelsInSmallFormat: true
            }
        });

    $stateProvider
        .state('shop.beforeconvenience', {
            url: '/before-convenience',
            data: {
                analytics: 'bws:web:before-convenience',
                pageMetadata: [
                    'PageMetadataService', function (pageMetadataService) {
                        return pageMetadataService.getMetadata({ name: 'Before Convenience - BWS Online' });
                    }
                ]
            },
            views: {
                'dynamic-content-top@': {
                    template: '<oly-dynamic-content oly-dc-url-schedule class="dynamic-content2-panelTop"></oly-dynamic-content>'
                },
                'dynamic-content-bottom@': {
                    template: '<oly-dynamic-content oly-dc-url-schedule="bottom" class="dynamic-content2-panelBottom"></oly-dynamic-content>'
                },
                'aem-view@': {
                    template: '<wow-aem-portal project="generic" is-partial="true"></wow-aem-portal>'
                }
            }
        })
        .state('shop.beforeconvenience.page', {
            url: '/:page'
        })
        .state('shop.beforeconvenience.page.page', {
            url: '/:page'
        })
        .state('shop.beforeconvenience.page.page.page', {
            url: '/:page'
        });
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/configuration/routes/inspiration.js
 **/